import { api } from "@/configs/axios"

export type Notification = {
  id: number
  username: string
  email: string
  userId: string
  message: string
  read: number
  created_at: string
  updated_at: string
}

export class NotificationService {

  async me() {
    try {
      const { data } = await api.get<Notification | null>("/notifications")

      return data
    } catch (e) {
      console.error(e)
      return null
    }
  }
}

export const notificationServiceInstance = new NotificationService()
